import type { UIPaymentGroups, UIPayoutGroups } from 'store/formatters';
import { isMethodAvailable } from 'utils';

import type { Limits } from '../../store/models';

export const getSortedEventData = (methods: UIPayoutGroups[] | UIPaymentGroups[]) => {
  const unavailableMethods: string[] = [];
  const availableMethods: string[] = [];

  methods.forEach((x) => {
    const name = x.name;
    if (isMethodAvailable(x)) {
      availableMethods.push(name);
    } else {
      unavailableMethods.push(name);
    }
  });

  return {
    unavailablePayGroups: unavailableMethods.length ? unavailableMethods : null,
    availablePayGroups: availableMethods.length ? availableMethods : null,
  };
};

export const getPayGroupCashierContext = (
  method: UIPaymentGroups | UIPayoutGroups | undefined,
  limits?: Limits | null,
) => {
  if (method) {
    const { min, max } = limits || method.limits || {};
    const data = {
      ...(min && {
        min_amount: min,
      }),
      ...(max && {
        max_amount: max,
      }),
      pay_group: method.name,
    };
    return {
      schema: 'iglu:com.psp/context_pay_group_cashier/jsonschema/3-0-0',
      data,
    };
  }

  return {
    schema: 'iglu:com.psp/context_pay_group_cashier/jsonschema/3-0-0',
    data: {},
  };
};
